// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4161c957","239":"bf950008","453":"cecb4ccd","667":"06a87a57"}[chunkId] + ".chunk.js";
};